import { Trans } from 'react-i18next';

import { Link, LinkTarget } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../translations';

export const ExternalDocumentationStorageLimitExceededTranslation = (): JSX.Element => (
   <Trans
      i18nKey={patientMedicalInformationTranslationKeys.externalDocumentationStorageLimitExceeded}
      components={{
         link: (
            <Link
               testId={'buyExtraStorageLimit'}
               target={LinkTarget.BLANK}
               label={patientMedicalInformationTranslationKeys.buyExtraStorageLimit}
               href={'https://dreryk.pl/produkty/egabinet/cennik-egabinet/'}
               block={false}
            />
         ),
      }}
   />
);
